import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartData,
  ChartOptions,
  Filler,
  Plugin,
} from 'chart.js';
import { AnyObject } from 'chart.js/dist/types/basic';
import { Line, Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

interface ChartProps<T = number> {
  type: 'line' | 'bar';
  data: ChartData<'bar' | 'line', T[], string>;
  options?: ChartOptions<'bar' | 'line'>;
  plugins?: Plugin[];
}

function Chart<T = number>({
  type,
  data,
  options,
  plugins,
}: ChartProps<T>): JSX.Element {
  switch (type) {
    case 'line':
      return (
        <Line
          data={data as ChartData<'line', T[], string>}
          options={options}
          plugins={plugins || ([] as Plugin<'line', AnyObject>[] | undefined)}
        />
      );
    case 'bar':
      return (
        <Bar data={data as ChartData<'bar', T[], string>} options={options} />
      );
    default:
      return <>Please provide a valid chart type</>;
  }
}

export default Chart;
